// @flow

import { request } from '../../utils'

export const addToCartLancome = (customerId: string, subscriberId: string, productId: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    request({
      url: '/on/demandware.store/Sites-lancome-de-Site/de_DE/Cart-AddProduct?ajax=true',
      data: {
        pid: productId,
        quantity: '1'
      },
      processResponse: (xhr) => {
        if (xhr.status >= 200 && xhr.status < 400) {
          resolve()
        } else {
          reject(new Error('Add-to-cart failed.'))
        }
      }
    })
  })
}
